import React, { useState } from "react";
import Navbar from "../navbar/Navbar";
import Sidebar from "../sidebar/Sidebar";
import "./ShareyLayout.css";
import { Outlet, Link } from "react-router-dom";
import SmallSidebar from "../sidebar/SmallSidebar/SmallSidebar";

const SharedLayout = () => {
  const [showSideBar, setShowSidebar] = React.useState(false);

  const toggleSidebar = () => {
    setShowSidebar(!showSideBar);
  };

  return (
    <section>
      <main className="dashboard">
        <SmallSidebar showSideBar={showSideBar} toggleSidebar={toggleSidebar} />
        <Sidebar showSideBar={showSideBar} />
        <div style={{ minWidth: 0 }}>
          <Navbar toggleSidebar={toggleSidebar} />
          <div className="dashboard-page">
            <Outlet />
          </div>
        </div>
      </main>
    </section>
  );
};
export default SharedLayout;
